<template>
  <div>
    <span v-if="size<basket_config.min_count" class="message">
      <b-badge
        variant="warning"
      >Select {{ basket_config.min_count }} - {{ basket_config.max_count }} recipes in total.</b-badge>
    </span>
    <span v-if="ready && (basket_config.max_count - size)>0" class="message">
      <b-badge
        variant="warning"
      >You can add up to {{ basket_config.max_count - size }} more {{ (basket_config.max_count - size) | pluralize('recipe','recipes')}}</b-badge>
    </span>
    <span v-if="size>basket_config.max_count" class="message">
      <b-badge
        variant="warning error"
      >Remove {{ size - basket_config.max_count }} {{ (size - basket_config.max_count) | pluralize('recipe','recipes')}} to continue</b-badge>
    </span>
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from "vuex";
export default {
    name: 'basket-validation',
    computed: {
        ...mapState({
            basket_config: state => state.basket.config,
            discount: state => state.basket.discountPercent,
            meal_preferences: state => state.profile.meal_preferences
        }),
        ...mapGetters({
            total: 'basket/total',
            last_added_item: 'basket/last_added_item',
            size: 'basket/size',
            ready: 'basket/ready'
        })
    }
}
</script>
